<script>
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import Card from "@/pages/components/card.vue";
import App from "@/pages/layouts/app.vue";
import {Link} from "@inertiajs/vue3";

export default {
	components: {Link, App, Card},
	mixins: [Datatable]
}
</script>

<template>
	<App title="Meetmiddelen">
		<template #topButtons>
			<Link :href="route('tester_types.create')" class="btn btn-primary">
				<i class="bi bi-plus-lg"></i>
				Meetmiddel toevoegen
			</Link>
		</template>

		<Card class="mb-4">
			<Table ref="table" :config="tableConfig"/>
		</Card>
	</App>
</template>